import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import '@tencent/tpm-meeting/lib/SearchBox/style';
import { ItemProps } from '@tencent/tpm-meeting/esm/SearchBox/interface';
import { useNavigate } from 'react-router-dom';
import SearchBox from '@tencent/tpm-meeting/lib/SearchBox';
import PageSection from '@/tpss/pages/comps/PageSection';
import { IProduct, ProductPatchModeOffline } from '@/tpss/types';

export interface ProductListBannerProps {
  products: IProduct[];
}

const ProductListBanner: React.FC<ProductListBannerProps> = ({ products }) => {
  const [inputValue, setInputValue] = useState('');
  const [filterList, setFilterList] = useState<ItemProps[]>([]);
  const navigate = useNavigate();

  const onSearch = (value: string | undefined) => {
    console.log('onSearch', value);
  };

  const transProductsToSearchItems = (list: IProduct[]) => {
    console.log('transProductsToSearchItems', list);
    return list?.map((prod) => ({
      title: prod.ProductName,
      onClick: () => {
        console.log('click item', prod);
        navigate(`/product/${prod.ID}/package/0`);
      }
    }));
  };

  const onChange = (value: string | undefined) => {
    setInputValue(value || '');
    const filteredList = products?.filter(
      (prod) =>
        prod.ProductName?.toLowerCase()?.includes((value || '')?.toLowerCase()) &&
        prod.ProductPatchMode !== ProductPatchModeOffline
    );
    if (filteredList?.length === 0)
      return setFilterList([
        { title: '没有找到结果，请重新输入', className: 'noResult' }
      ]);
    setFilterList(transProductsToSearchItems(filteredList));
  };

  useEffect(() => {
    // const list = transCategoryProductTree2ProductList(productList);
    // const list = transTPSS2ProductList(productList);
    // console.log('---------------', products, '----------------');
    // setAllSubProductList(list);
    const filteredList = products?.filter(
      (prod) => prod.ProductPatchMode !== ProductPatchModeOffline
    );
    setFilterList(transProductsToSearchItems(filteredList));
  }, [products]);

  return (
    <PageSection className={styles.productHeroContainer}>
      <div className={styles.bg}></div>
      <div className={styles.maskContainer}>
        <div className={styles.rightMask}></div>
        <div className={styles.leftMask}></div>
      </div>
      <div></div>
      <div className={styles.contentWrapper}>
        <header className={styles.headerWrapper}>
          <img className={styles.icon} src="./img/banner-icon.svg" alt="" />
          <h1 className={styles.title}>腾讯私有化软件下载中心</h1>
        </header>
        <div className={styles.searchWrapper}>
          <SearchBox
            className={styles.search}
            placeholder={'搜索产品名称'}
            value={inputValue}
            onSearch={onSearch}
            onClear={() => {
              setInputValue('');
            }}
            onChange={onChange}
            list={{
              onClose: (value) => {
                console.log('onClose', value);
              },
              items: filterList
            }}
          />
        </div>
      </div>
    </PageSection>
  );
};

export default ProductListBanner;
